/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import IU from '../../../_utils/img/img-utils';
import { aboveRecommendedDpi } from './dpi-classification';

const PORTRAIT = 0;
const LANDSCAPE = 1;
const EXCLUDED_PRINT_SIZE_TITLES = ['Wallet'];

const aspectRatio = ({ x, y }) => {
  const ratio = x / y;
  const orientation = x < y ? PORTRAIT : LANDSCAPE;
  if (orientation === PORTRAIT) {
    return 1 / ratio;
  }

  return ratio;
};

const aspectRatioDelta = (a, b) =>
  Math.abs(Math.round(a * 100) - Math.round(b * 100)); // Round to the nearest integer to avoid float comparisons

/**
 * Find the print size that best matches the photo aspect ratio and results in DPI at or above recommended level
 * When multiple print sizes match criteria, the largest is selected
 * Returns undefined if there are no suitable matches, or if the feature is disabled
 */
function findRecommendedPrintSize(sizes, photo) {
  if (!photo || !photo.raw_dimensions) {
    return undefined;
  }

  const photoAspectRatio = aspectRatio({
    x: photo.raw_dimensions.w,
    y: photo.raw_dimensions.h
  });
  if (Number.isNaN(photoAspectRatio)) {
    return undefined;
  }

  // Exclude any print sizes not recommendable - This title check is done elsewhere in the app :/
  const availableSizes = sizes.filter(
    size => !EXCLUDED_PRINT_SIZE_TITLES.includes(size.title)
  );

  // Find the closest rounded aspect ratio to photo
  const closestAspectRatioDelta = Math.min(
    ...availableSizes.map(size => {
      const [x, y] = size.area;
      const sizeAspectRatio = aspectRatio({ x, y });
      return aspectRatioDelta(photoAspectRatio, sizeAspectRatio);
    })
  );

  // Find all the print sizes that match criteria having the closest aspect ratio and DPI above recommended level
  const bestFitSizes = availableSizes.filter(size => {
    const [x, y] = size.area;
    const sizeAspectRatio = aspectRatio({ x, y });
    const dpi = IU.imgHelpers.getPhotoDPI({
      size_area: size.area,
      raw_dimensions: photo.raw_dimensions
    });
    const sizeAspectRatioDelta = aspectRatioDelta(
      photoAspectRatio,
      sizeAspectRatio
    );

    return (
      sizeAspectRatioDelta === closestAspectRatioDelta && aboveRecommendedDpi(dpi)
    ); // DPI is rounded as a <0.5 difference is indistinguishable so prefer to be positively biased
  });

  if (!bestFitSizes.length) {
    return undefined;
  }

  // Sort by print size and return the largest
  return bestFitSizes.sort((a, b) => {
    return b.area.reduce((x, y) => x * y) - a.area.reduce((x, y) => x * y);
  })[0];
}

export default findRecommendedPrintSize;
